'use client';

import React, { useMemo } from 'react';
import { ConfigProvider, App } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import enUS from 'antd/locale/en_US';
import { useTranslation } from 'react-i18next';
import './antd-custom.scss';
import { theme } from './theme-config';

interface AntdThemeProviderProps {
  children: React.ReactNode;
}

export const AntdThemeProvider: React.FC<AntdThemeProviderProps> = ({
  children,
}) => {
  const { i18n } = useTranslation();

  // 根据当前语言选择 Ant Design 语言
  const antdLocale = useMemo(() => {
    switch (i18n.language) {
      case 'zh-CN':
        return zhCN;
      case 'en':
        return enUS;
      default:
        return enUS;
    }
  }, [i18n.language]);

  return (
    <ConfigProvider theme={theme} locale={antdLocale} componentSize="large">
      <App>{children}</App>
    </ConfigProvider>
  );
};
